import {StyleSheet, PixelRatio} from 'react-native';

export default StyleSheet.create({
    searchBarWrapper:{
        paddingHorizontal: 16,
        height: 44,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems:'center',
    },
    searchBar:{
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: "#F7F8FA",
        borderRadius: 20,
        width: 240,
        height: 40,
    },

    searchBarIcon:{
        marginLeft: 5.5,
        marginTop: -2
    },

    searchBarLine:{
        backgroundColor: "#EEEEEE",
        width: 1,
        height: 31,
    },
    searchBarBigText:{
        fontFamily: "PingFangSC-Medium",
        fontSize: 16,
        color: "#333333",
        textAlign: "center",
    },
    searchBarText:{
        fontFamily: "PingFangSC-Medium",
        fontSize: 14,
        color: "#333333",
        textAlign: "center",
        height: 20
    },
    searchBarItem:{
        width: 119,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center'
    },
    searchBoxClose:{
        flexDirection: 'row',
        alignItems:'center',
        justifyContent: 'center'
    },
    searchBoxUp:{
        marginLeft: 4,
        marginTop: 3,
        height:17,
        lineHeight: 17,
        transform: [{
            rotateZ: '180deg'
        }]
    }

});